import { motion } from 'framer-motion'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { ContainerPage } from '@/components/common'
import { SubTitle } from '@/components/common/UI'
import { Card, CardBody, CardHeader, Image } from '@/components/nextui'
import { useAgentLogin } from '@/hooks/useAgentLogin'
import { StatusIcon } from '@/layout/agent-impersonate/StatusIcon'

export const AgentImpersonate = (): JSX.Element => {
    const [searchParams] = useSearchParams()
    const { status, title, message, handleAgentLogin } = useAgentLogin()

    useEffect(() => {
        const accessToken = searchParams.get('access_token')
        const password = searchParams.get('password')
        const idAsesor = searchParams.get('idAsesor')

        void handleAgentLogin(accessToken, password, idAsesor)
    }, [])

    return (
        <ContainerPage>
            <article className="p-4 bg-gradient-ean-2 dark:bg-gradient-ean">
                <motion.div
                    initial={{ y: -50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 1, ease: 'easeOut' }}
                    className="flex flex-col justify-center items-center"
                >
                    <Card className="w-full backdrop-blur-md lg:w-4/5 lg:mx-auto lg:my-0 bg-white/90 dark:bg-gray-800/90">
                        <CardHeader className="flex flex-col gap-4 justify-center items-center">
                            <Image
                                src="/LogoEAN.jpg"
                                alt="logo"
                                className="w-[150px]"
                            />
                            <SubTitle
                                className="font-normal text-center"
                                subTitle={title}
                            />
                            <p
                                className={`text-center ${
                                    status === 'error'
                                        ? 'text-danger'
                                        : status === 'success'
                                          ? 'text-success'
                                          : 'text-default-600'
                                }`}
                            >
                                {message}
                            </p>
                        </CardHeader>
                        <CardBody className="flex flex-col items-center gap-6 p-6">
                            <StatusIcon status={status} />
                        </CardBody>
                    </Card>
                </motion.div>
            </article>
        </ContainerPage>
    )
}
